<ce-layout-header-container class="CtepHeader-container">
    <div class="CtepHeader-content flex-row flex-center flex-middle">
        <h1 class="CtepHeader-title u-text-title-md u-color-text-primary">CTEP Event Log</h1>
    </div>
</ce-layout-header-container>
